let env = process.env.VUE_APP_ENV
export default env
